import React from "react";
import { motion } from "framer-motion";
import Mouse from "../components/Mouse";
import TodoList from "../components/TodoList";

const PageProject3 = () => {
  const pageProjectAnim = {
    initial: {
      opacity: 0,
      x: Math.floor(Math.random() * 900 * (Math.random() > 0.4 ? 1 : -1)),
      y: Math.floor(Math.random() * 1500 * (Math.random() > 0.4 ? 1 : -1)),
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
    },
  };

  const closeWindow = () => {
    window.close();
  };

  return (
    <div>
      <Mouse />
      <div className="page-project">
        <div className="title-page-project">
          <div className="icone hover" onClick={closeWindow}>
            <h3>
              {/* Icône sur le site https://www.toptal.com/designers/htmlarrows/symbols/  */}
              <i className="fa-solid fa-xmark"></i>
            </h3>
          </div>

          <motion.div
            initial="initial"
            animate="visible"
            variants={pageProjectAnim}
            transition={{ duration: 1.2 }}
            // className="img-content"
          >
            <div className="projet-container-3">
              <TodoList />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default PageProject3;
